import Model from '@/models/Model'

export default class WhSubfamily extends Model {
	
	static includes = [
		'wh_family',
	]

	get wh_family_name() {
		return this.wh_family ? this.wh_family.family : '-'
	}


    resource() {
        return 'wh_subfamily'
    }
    static itemText() {
        return 'subfamily'
    }
    static itemValue() {
        return 'id'
    }
}